import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/psx-frontend/psx-frontend/app/learning/[slug]/LearningArticleClient.tsx");
